/**
 * External documentation links
 */
export const PROOFING_FLOW_DOCUMENTATION_URL =
  "https://www.notion.so/infinitaslearning/Proofing-Flow-Manager-2f4ee2ab878580ae8422c9655b338a7b";

export const SUPPORT_CONTACT_URL = "https://infinitaslearning.tfaforms.net/1415";

/**
 * Analytics
 */
export const ANALYTICS_PLATFORM = "Edify" as const;
export const ANALYTICS_PLATFORM_VARIANT = "proofing-flow" as const;

/**
 * Pagination defaults for data grids
 */
export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE = 0;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const;
